import { FC } from 'react';

import { Membership, PaymentInstrument } from '@bpm-web-app/supreme-api-sdk';
import { Button } from '../../../components/button/button';
import { Modal } from '../../../components/modal/modal';
import planStyles from '../your-plan.module.css';
import styles from './resume-button.module.css';
import { PausedMembershipModal } from './paused-membership-modal';
import { useResume } from './use-resume';

type Props = {
    membership: Membership
    paymentInstrument?: PaymentInstrument
};

export const ResumeButton: FC<Props> = ({ membership, paymentInstrument }) => {
    const { isConfirmationOpen, setConfirmationOpen, platform, resumeSubscription, isLoading } = useResume();

    return (
        <>
            <Button
                type="button"
                onClick={() => setConfirmationOpen(true)}
                className={planStyles['plan__button']}
            >
                Resume Subscription
            </Button>

            <Modal
                title="Resume Subscription"
                isOpen={isConfirmationOpen}
                onClose={() => setConfirmationOpen(false)}
            >
                {membership.is_paused ? (
                    <PausedMembershipModal
                        paymentInstrument={paymentInstrument}
                        membership={membership}
                        platform={platform}
                    >
                        Your paused subscription will start working immediately.
                    </PausedMembershipModal>
                ) : (
                    <p className={styles['description-text']}>Your subscription will continue as usual, and your planned pause will be canceled.</p>
                )}

                <Button
                    type="button"
                    variant="primary"
                    isLoading={isLoading}
                    onClick={resumeSubscription}
                    className={styles['confirm-button']}
                >
                    Resume Subscription
                </Button>
            </Modal>
        </>
    );
};
